import { Box } from "@material-ui/core";

export type { BoxProps as IBoxProps } from "@material-ui/core";

export default Box;
